export class Icon {
  constructor(public name: string, public classes: string, public count: number, public order: number) {}
}
